import React from 'react';

const OrderList=()=>{
  return(
    <div className="col-sm">
      <h2>Order List</h2>
      
    </div>
  );
}

export default OrderList;